module.exports = __webpack_public_path__ + "static/img/0.98d3790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsdh/0.png
// module id = U9bx
// module chunks = 0